module.exports = __webpack_public_path__ + "img/4.2f2d3ecd.png";